import BaseListFilter, {
  type BaseListFilterType,
} from "@search/store/filters/base/BaseListFilter";

class StringListFilter extends BaseListFilter {
  constructor({
    name = "stringList",
    label = name,
    value,
  }: BaseListFilterType) {
    super({ label, name, value: value as Array<string> });
  }

  get defaultValue() {
    return super.defaultValue as Array<string>;
  }

  get initialValue() {
    return super.initialValue as Array<string>;
  }

  get value() {
    return super.value as Array<string>;
  }
}

export default StringListFilter;
export { StringListFilter };
